function formatDate(date) {
  var date = new Date(date * 1000)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
  var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  //   return YY + MM + DD + ' ' + hh + mm + ss
  return MM + DD
}

function formatDay(date) {
  var date = new Date(date * 1000)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' '

  var weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  var weekday = weekArr[date.getDay()]

  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  //   return YY + MM + DD + ' ' + hh + mm + ss
  return YY + MM + DD + weekday
}

export {formatDate,formatDay}



// WEBPACK FOOTER //
// ./src/assets/js/monthday.js